module.exports = __webpack_public_path__ + "img/down-layer.ee594418.svg";